export default {
  hasActivity: state => {
    return !!state.activity && !!state.activity.id
  }
}



// WEBPACK FOOTER //
// ./~/vue-components/activity-notes/store/actions.js